import { StyledRow } from './Row.styled'

const Row = ({ ...props }) => {
  return <StyledRow {...props} />
}

export default Row
